import { render, staticRenderFns } from "./CenterHeadMenu.vue?vue&type=template&id=ec12080a&scoped=true"
import script from "./CenterHeadMenu.vue?vue&type=script&lang=js"
export * from "./CenterHeadMenu.vue?vue&type=script&lang=js"
import style0 from "./CenterHeadMenu.vue?vue&type=style&index=0&id=ec12080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec12080a",
  null
  
)

export default component.exports